export enum LikesFilterEnum {
  OnlyNotifications = 'OnlyNotifications',
  All = 'All',
}

export interface OnboardingInfos {
  key: string;
  order: number;
  svgPath?: string;
  imgPath?: string;
}

export interface SurveyChat {
  id: number;
  conviveComment: string;
  conviveCommentDate: Date;
  managerComment?: string;
  managerCommentDate?: Date;
  note: string;
  restaurantLibelle?: string;
}

export interface AntiGaspiHistory {
  date: Date;
  source: AntiGaspiAlertSource;
  restaurantId: number;
}

export type AntiGaspiAlertSource = 'first-access' | 'first-order';
